import { Waves, TreePine, Building2, UtensilsCrossed, Laptop, Heart, Users, PawPrint } from "lucide-react";
import { Fish, Fisherman, OceanWaves } from "@/components/KonkanVectors";

const V = ({ children, className }) => (
  <div className={`absolute pointer-events-none select-none ${className}`} aria-hidden="true">{children}</div>
);

const EXPERIENCES = [
  { icon: Waves, label: "Beachfront" },
  { icon: TreePine, label: "Nature Retreats" },
  { icon: Building2, label: "Heritage Homes" },
  { icon: UtensilsCrossed, label: "Authentic Food" },
  { icon: Laptop, label: "Workation" },
  { icon: Heart, label: "Romantic Escape" },
  { icon: Users, label: "Family Vacation" },
  { icon: PawPrint, label: "Pet Friendly" },
];

export const ExperienceGrid = () => (
  <section className="relative py-12 md:py-14 px-6 md:px-8 bg-[#FAF8F3] border-y border-border/20 overflow-hidden" data-testid="experience-section">
    <V className="right-2 md:right-6 bottom-4 w-24 md:w-36 opacity-[0.18]"><Fish /></V>
    <V className="-left-2 md:left-4 top-0 w-28 md:w-40 opacity-[0.18]"><Fisherman /></V>
    <V className="left-1/4 right-1/4 bottom-0 w-full max-w-xs opacity-[0.10]"><OceanWaves /></V>
    <div className="max-w-7xl mx-auto relative z-10">
      <h2 className="text-2xl md:text-3xl font-bold text-foreground mb-8">Browse by Experience</h2>
      <div className="grid grid-cols-4 md:grid-cols-8 gap-4 md:gap-6">
        {EXPERIENCES.map((exp, i) => (
          <div key={i} className="flex flex-col items-center gap-2 py-3" data-testid={`experience-${i}`}>
            <div className="w-12 h-12 md:w-14 md:h-14 rounded-full border border-border/50 flex items-center justify-center">
              <exp.icon className="w-5 h-5 md:w-6 md:h-6 text-muted-foreground" />
            </div>
            <span className="text-xs font-medium text-center text-muted-foreground">{exp.label}</span>
          </div>
        ))}
      </div>
    </div>
  </section>
);
